<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="toc">
<h2 class="contentsHead">Contents</h2>
<p class="contentsEntry"><a href="#/OnceAMarine_foreword#foreword">Foreword by Colonel Bryan McCoy, USMC</a></p>
<p class="contentsEntry"><a href="#/OnceAMarine_collaborator#collaborator">Collaborator’s Note: Working with Gunny Pop</a></p>
<p class="contentsEntry"><a href="#/OnceAMarine_introduction#introduction">Introduction and Acknowledgments</a></p>
<p class="contentsEntry"><a href="#/OnceAMarine_part1#part1">PART 1: Bang—I’m Not Dead</a></p>
<p class="contentsEntry"><span href="#/OnceAMarine_part2#part2" title="Link target outside of Sample">PART 2: Making This Marine</span></p>
<p class="contentsEntry"><span href="#/OnceAMarine_epilogue#epilogue" title="Link target outside of Sample">Epilogue: The Tip of the Spear</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// OnceAMarine_toc.vue?78499c21